import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class AppauthService {
  constructor(private httpClient: HttpClient,  private router: Router) {}

   public logout(user: boolean) {
    user = false;
    localStorage.clear();
    sessionStorage.clear();
    location.reload();
  }

  public isLoggedIn(): boolean {
    const user = localStorage.getItem('SecurityToken');
    if (user != null) {
      return true;
    } else {
      return false;
    }
  }

  public getBearerToken() {
    this.getToken().subscribe(res => {
      const urlLocation = location;
      localStorage.setItem('SecurityToken', environment.SecurityToken);
      urlLocation.href = '/industries' + urlLocation.pathname;
    });
  }

  public isFormActive(): boolean {
    const status = history.state;
    if ( status === undefined || status === null) {
      return false;
    } else {
      return true;
    }
  }

  public isFormSubmitted(data: object, requestName: string) {
    this.formSubmission(data).subscribe(res => {
      if (res) {
        this.router.navigate(['thank-you'], { state: { data: requestName }});
      } else {
        this.router.navigate(['404']);
      }
    });
  }

  private formSubmission(emailRequest): Observable<any> {
    return this.httpClient.post(environment.emailEndPointAPI,
      emailRequest, { headers: { authToken: environment.emailAuthToken }}).pipe(res => {
      return res;
    });
  }

  private getToken(): Observable<string> {
    return this.httpClient.get<string>(environment.secureDoc).pipe(res => {
      return res;
    });
  }

}
